import { bindMethod } from 'helpers/bind';
import InternalPage from 'navigation/pages/InternalPage';
class Orders extends InternalPage {
    initialized() {
        super.initialized();
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this.parent
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        if (this.refs.viewMore)
            this.refs.viewMore[method]('click', this.onViewMore);
    }
    onViewMore = () => {
        this.refs.viewMore.parentElement.style.display = 'none';
        this.refs.moreList.classList.toggle('visible');
    };
}
export default Orders;
